export default "__VITE_ASSET__D4ErbKId__"